<template>
  <div id="show-house">
    <div class="content" v-loading="loading">

      <!-- 标题 -->
      <div class="title">
        <i class="el-icon-s-management"></i>
        <span>个人信息详情</span>

        <!-- 返回按钮 -->
        <div class="back">
          <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
        </div>
      </div>

      <!-- 显示信息 -->
      <div class="main" v-show="data.length!=0" v-loading="loading"> 
      <div v-for="(item,index) in data" :key="index">
      <div class="main" >
      <div v-show="index==0">
        <el-row :gutter="10">
        <el-col :xs="24" :sm="6" :md="3" :lg="3"><div class="item-title">头像:</div></el-col>
          <el-avatar shape="square" :size="100" :src="item.m_img" class="serve-img"></el-avatar>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">名字:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.m_name}}</div></el-col>
          <el-col :xs="24" :sm="6" :md="3" :lg="3"><div class="item-title">会员编号:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9"><div class="msg">{{item.c_num}}</div></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">性别:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.m_sex}}</div></el-col>  
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">出生日期:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.m_birth}}</div></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">身份证号:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.m_idNum}}</div></el-col>
           <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">手机号码:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.m_tel}}</div></el-col>
        </el-row>
        </div>
     
         <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">{{item.c_cert}}：</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.c_level}}</div></el-col>
          
        </el-row>
        <el-row :gutter="10">
           <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">开始日期:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.c_startDate}}</div></el-col>
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">有效截止日期:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.c_endDate}}</div></el-col>
        </el-row>
      
        <!-- <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">所属协会:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">广西跆拳道协会</div></el-col>
          <el-col :xs="24" :sm="6" :md="3" :lg="3" ><div class="item-title">地址:</div></el-col>
          <el-col :xs="24" :sm="18" :md="9" :lg="9" ><div class="msg">{{item.address}}</div></el-col>
        </el-row> -->
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return { 
      value:3.7 ,
      loading:true,
      data: [],//信息    
    };
  },
  methods: {
    //返回信息列表
    back(){
      this.$router.push({path:'/home/teacher'});
    },

    // 格式化时间
    switchTimeFormat(time) {
      const dateTime = new Date(time);
      const year = dateTime.getFullYear();
      const month = dateTime.getMonth() + 1;
      const date = dateTime.getDate();
      return `${year}-${this.PrefixInteger(month,2)}-${this.PrefixInteger(date,2)}`;
    },

    //格式化数字
    PrefixInteger(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },

  },
  mounted() {//创建时获取数据
    console.log(this.$route.params.id);
    this.axios.post("/teacher/getPerson", {
      id:this.$route.params.id
    })
    .then((res) => {
      console.log(res);
      if(res.data.code=='200'){
        this.loading=false;
        //this.data=this.formateData(res.data.data)
        var list = res.data.data.list;
        for(var i=0;i<list.length;i++){
            list[i].m_birth=this.switchTimeFormat(list[i].m_birth);
            list[i].c_startDate=this.switchTimeFormat(list[i].c_startDate);
            list[i].c_endDate=this.switchTimeFormat(list[i].c_endDate);
            list[i].m_img = list[i].m_img?"https://a.gxtkd.org.cn/api"+list[i].m_img:'/img/avator.jpg';
            this.data.push(list[i]);
          }
        //this.data=res.data.data;
        //console.log(this.data)
      }
    })
    .catch(err=> {
      console.log(err)
    })
  },
};
</script>
<style lang="less">
.el-avatar>img{
  height:100%;
  width: 100%;
}
</style>
<style lang="less" scoped>
@import "../assets/less/base.less";
#show-house {
  color: @fontColor;
  background-color: white;
  height: 100%;
}
.msg{
  height: 40px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.choose .el-button--text{
  margin-top: 10px;
  color: #A7B1C2;
  padding: 15px 20px;
}
.btn-choose.el-button--text{
  color: @fontColor;
  border: 1px solid @lineColor;
}
.tab-content{
  border: 1px solid @lineColor;
}
.item-title{
  color: @fontColor;
  font-weight: 600;
  text-align: right;
  line-height: 45px;
  font-size: 14px;
}
.msg{
  color: @fontColor;
  line-height: 45px;
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .item-title{
    text-align: left;
  }
}
.el-tabs--border-card>.el-tabs__content{
  padding: 30px;
}
.add-btn{
  text-align: right;
  padding: 5px 20px;
  padding-top:20px;
  margin-top: 30px;
  border-top: 1px solid @lineColor;
}
.searchTel-btn{
  background: @blueColor;
  border-color: @blueColor;
}
.rate{
  height: 45px;
  align-items: center;
  display: flex;
}
</style>